import {
	BaseError,
} from './BaseError';

export class GetCompanyLandsError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
